import { EsignConsentModel } from '@tcs/client-portal-api/platform_generated';
import { useQuery } from 'react-query';

interface Props {
  loading: boolean;
  data?: EsignConsentModel;
}

export const useEsignConsentStatus = (accountId: string): Props => {
  const { data, isLoading: loading } = useQuery<EsignConsentModel, Error>(
    `/accounts/${accountId}/EsignConsentStatus`,
    {
      refetchOnMount: false,
    }
  );
  return {
    loading,
    data,
  };
};

export default useEsignConsentStatus;
